import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { cpfCnpjValidatorDirective } from 'app/core/helpers/cpfCnpjValidatorDirective';
import { ErrorHandlerService } from 'app/core/http/services/error-handler.service';
import { OrganizationLocationService } from 'app/core/http/services/organization-location.service';
import { PractitionerService } from 'app/core/http/services/practitioner.service';
import { PractitionerOrganizationAffiliationService } from 'app/core/http/services/practititoner-organization-affiliation.service';
import { genderTranslated } from 'app/core/interfaces/currentUser';
import { Location } from 'app/core/interfaces/location';
import { Practitioner } from 'app/core/interfaces/practitioner';
import { ageValidator } from 'app/core/validators/AgeValidator';
import { validateImageFile } from 'app/core/validators/validateImageFile';
import { BaseComponent } from 'app/modules/shared/components/base.component';
1

@Component({
  selector: 'app-practitioner-registration-by-organization',
  templateUrl: './practitioner-registration.component.html',
  styleUrls: ['./practitioner-registration.component.css']
})
export class PractitionerRegistrationComponent extends BaseComponent implements OnInit {

  @Input() practitioner: Practitioner = <Practitioner>{};
  @Input() practitioner_id: string = ""
  @Input() mode = 'UPDATE';
  @Output() onUpdatePractitioner = new EventEmitter<any>();

  public form: FormGroup;
  public userEmail: string = '';
  public invalidForm = false;
  public titles = ['Dados Cadastrais', 'Dados Profissionais', 'Endereço'];
  public genders: genderTranslated[] = [];
  public isSaving = false;

  public organizationLocation !: Location
  public hasLocation: boolean = false

  profilePictureUrl: string | ArrayBuffer | null = null;
  selectedFileName: string | null = null;


  constructor(
    private fb: FormBuilder,
    private injector: Injector,
    private practitionerService: PractitionerService,
    private practitionerOrganizationAffiliationService: PractitionerOrganizationAffiliationService,
    private organizationLocationService: OrganizationLocationService,
    private cdr: ChangeDetectorRef,
    private errorHandler: ErrorHandlerService
  ) {
    super(injector);

    this.form = this.fb.group({
      practitioner_id: new FormControl(null, [Validators.nullValidator]),
      name: new FormControl('', [Validators.required, Validators.pattern(/^[A-Za-zÀ-ÿ\s]+$/)]),
      cpf: new FormControl('', [Validators.required, cpfCnpjValidatorDirective.validate, Validators.pattern(/^[0-9]{11}$/)]),
      mobile: new FormControl('', [Validators.required, Validators.pattern(/^[0-9]{11}$/)]),
      active: new FormControl(true),
      photo: new FormControl(''),
    });
  }

  async ngOnInit() {
    this.showSuccessMessage = false;
    this.showErrorMessage = false;
    this.genders = this.layout.initTranslatedgender();

    this.getOrganizationLocation()

    if (this.mode === 'UPDATE') {
      this.getPractitioner();
    }

   

  }

  allowOnlyLetters(event: KeyboardEvent): void {
    const inputChar = event.key;
    if (!/^[A-Za-zÀ-ÿ\s]$/.test(inputChar)) {
      event.preventDefault();
    }
  }

  onPasteName(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData?.getData('text') ?? '';
    const validNameRegex = /^[A-Za-zÀ-Üà-ü\s]+$/;
    if (!validNameRegex.test(clipboardData)) {
      event.preventDefault();
    }
  }

  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    const photoControl = this.form.controls['photo'];

    if (!file) {
      return;
    }

    const validationResult = validateImageFile(file, 4);

    if (!validationResult.isValid) {
      photoControl.setErrors(validationResult.errors);
      this.profilePictureUrl = null;
      this.selectedFileName = null;

      return;
    }

    photoControl.setErrors(null);
    this.selectedFileName = file.name;

    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result) {
        const base64 = reader.result as string;
        this.profilePictureUrl = base64;
        this.form.controls['photo'].setValue(base64);
      }
    };
    reader.readAsDataURL(file);
  }



  validateForm() {
    return !this.form.valid;
  }

  private getPractitioner() {

    this.practitionerService.showNew(this.practitioner_id).subscribe({
      next: (practitioner: Practitioner) => {
        this.practitioner = practitioner;

        let formattedMobile = this.practitioner.mobile || '';
        if (formattedMobile.startsWith('55')) {
          formattedMobile = formattedMobile.replace('55', '');
        }

        this.form.patchValue({
          practitioner_id: this.practitioner.practitioner_id,
          name: this.practitioner?.name,
          cpf: this.practitioner.cpf,
          mobile: formattedMobile,
          photo: this.practitioner.photo,
        });
        this.profilePictureUrl = this.practitioner.photo || this.defaultPractitionerPhoto;

        this.onUpdatePractitioner.emit(practitioner)
      },
      error: (err: HttpErrorResponse) => {
        
        this.showErrorMessage = true 
        this.messageError = err.message || err.error.message
      },
    });
  }

  getOrganizationLocation() {

      this.loading = true
      const organization_id = this.getUserLogged().id;
      this.organizationLocationService.showByOrganization(organization_id).subscribe({
        next: (organizationLocation: Location) => {
          this.organizationLocation = organizationLocation

          this.hasLocation = true
        },
        error: (error: HttpErrorResponse) => {
  
          const erroType = error?.error?.error
  
          this.messageWarning = error.message || error.error.message
          this.loading = false
  
        },
      });
    }

  save() {
    this.showErrorMessage = false;
    this.showSuccessMessage = false;
    this.form.markAllAsTouched();

    const errors = this.collectErrors();
    if (errors.length) {
      this.messageError = errors.join('\n');
      this.showErrorMessage = true;
      return;
    }

    this.isSaving = true;
    const practitionerId = this.practitioner_id  
    const organization_id = this.getUserLogged().id
    const practitionerFormValues = { ...this.practitioner, ...this.form.value };
    practitionerFormValues.mobile = `55${practitionerFormValues.mobile}`;

    this.practitionerService.updateByOrganization(practitionerId, organization_id, practitionerFormValues).subscribe({
      next: (practitioner: Practitioner) => {
        this.isSaving = false;
        this.showErrorMessage = false;
        this.showSuccessMessage = true;

        this.onUpdatePractitioner.emit(practitioner)
      },
      error: (error: HttpErrorResponse) => {
        this.isSaving = false;
        this.showErrorMessage = true;

        this.messageError = error.error?.message || this.errorHandler.getErrorMessage(error);
      },
    });
  }

  create() {
    this.showErrorMessage = false;
    this.showSuccessMessage = false;
    this.form.markAllAsTouched();


    const errors = this.collectErrors();

    if (errors.length) {
      this.messageError = errors.join('\n');
      this.showErrorMessage = true;
      return;
    }

    this.isSaving = true;
    const organization = this.getUserLogged()

    const practitionerFormValues = {
      ...this.form.value,
      mobile: `55${this.form.value.mobile}`,
      created_by_organization: {
        organization_id: organization.id,
        organization_name: organization.name
      },
      gender: "unknown"
    };

    

    this.practitionerService.createByOrganization(practitionerFormValues, organization.id).subscribe({
      next: (practitioner: Practitioner) => {

        this.onUpdatePractitioner.emit(practitioner);

        this.createAffiliation(practitioner)

         // Evita o uso de setTimeout desnecessário
        this.router.navigate(['organization-new/especialistas'], {
          queryParams: { tab: 'especialidade' }
        });


        this.isSaving = false;
        this.showErrorMessage = false;
        this.showSuccessMessage = true;
        this.loading = false;

      },
      error: (error: HttpErrorResponse) => {
        this.isSaving = false;
        this.loading = false;
        this.showErrorMessage = true;

        if (error.status === 413) {
          this.messageError = 'Imagem enviada ultrapassa o tamanho máximo permitido de 4MB.';
        } else {
          this.messageError = error?.error?.message || error.message || 'Erro ao salvar dados.';
        }
      }
    });
  }

   createAffiliation(practitioner: Practitioner) {

    const organization =  this.organizationLocation.organization
    const address = this.organizationLocation.address

    const organizationFilter = {
      organization_id: organization.organization_id,
      organization_name: organization.name,
      organization_photo: organization.photo,
      organization_address: address,
    };

    const practitionerFilter = {
      practitioner_id: practitioner.practitioner_id,
      practitioner_name: practitioner.name,
      practitioner_photo: practitioner.photo,
      practitioner_details: {
        accessibilities: practitioner.accessibilities,
        address: practitioner.address,
        communication: practitioner.communication,
        cpf: practitioner.cpf,
        qualification: practitioner.qualifications,
      },
    };

    const currentDate = new Date().toISOString();

    const affiliation = {
      ...organizationFilter,
      ...practitionerFilter,
      changeRequest: [],
      specialty: [],
      requestDateTime: currentDate,
      updateDateTime: currentDate,
      status: "accepted"
    };


      const organizationPratitionerAfffiliationFHIR = this.transformObjectToFHIR(affiliation);

      this.practitionerOrganizationAffiliationService.create(organizationPratitionerAfffiliationFHIR).subscribe({
        next: (resAffiliation) => {
         
          this.messageSuccess = "Médico Criado e vinculado a instituição com sucesso"
          this.showSuccessMessage = true

        },
        error: (response: HttpErrorResponse) => {

          this.messageWarning = "Médico Criado porém não foi possível vincular à instituição"
          this.showSuccessMessage = true

          // this.showErrorMessage = true
          // this.messageError = response.message
        },
      });
  }

  public transformObjectToFHIR(data: any) {
    return {
      resourceType: 'Affiliation',
      request: {
        id: data.practitioner_id,
        referenceType: 'Practitioner',
        display: data.practitioner_name,
        photo: data.practitioner_photo,
        details: data.practitioner_details
      },
      changeRequest: data.changeRequest,
      subject: {
        id: data.organization_id,
        referenceType: 'Organization',
        display: data.organization_name,
        photo: data.organization_photo,
        address: data.organization_address,
      },
      specialty: data.specialty,
      requestDateTime: data.requestDateTime,
      updateDateTime: data.updateDateTime,
      status: data.status
    };
  }

  private collectErrors(): string[] {
    const ctrls: any = this.form.controls;
    const errors: string[] = [];

    const requiredFields: string[] = [];
    if (ctrls.name.hasError('required')) {
      requiredFields.push('Nome');
    }
   
    if (ctrls.cpf.hasError('required')) {
      requiredFields.push('CPF');
    }
   
 
    if (requiredFields.length) {
      const lista = requiredFields.map((f) => `'${f}'`).join(', ');
      errors.push(`O campo: ${lista} é obrigatório`);
    }

    if (ctrls.name.hasError('pattern')) {
      errors.push('Nome deve conter apenas letras');
    }
   
    if (ctrls.cpf.hasError('pattern')) {
      errors.push('CPF inválido');
    }
  

    return errors;
  }

}
